import { adminT } from '@/i18n/adminCommon'

export const ELASTICSEARCH_MESSAGES = {
  de: {
    title: 'Elasticsearch',
    intro:
      'Status, Mapping-Rotation und Index-Aufräumen für das DWH-Search-Cluster.',

    statusOnline: 'Online',
    statusOffline: 'Offline / Fehler',
    clusterLocal: 'Local',
    clusterStage: 'Stage',
    clusterProd: 'Prod',
    clusterCustom: 'Custom',
    clusterUnknown: 'Unknown',
    refresh: 'Aktualisieren',

    warningEmptyTitle:
      'Alias/Index fehlt (z. B. award). Cluster ist leer oder Aliase fehlen.',
    warningEmptyBody:
      'Lokales Docker-ES ist oft leer. Stage-/Prod-Indizes siehst du unter stage.ffdwh.de / ffdwh.de (IAM dort hat ES-Zugriff).',
    warningForbiddenTitle: 'Kein Zugriff auf dieses Elasticsearch',
    warningForbiddenBody:
      'Die lokalen AWS-Credentials dürfen dieses OpenSearch nicht lesen (es:ESHttp*). Für Stage die Admin-UI auf stage.ffdwh.de nutzen.',

    kpiAwards: 'Awards',
    kpiReleases: 'Releases',
    kpiDynamicFields: 'Dynamic fields',
    kpiSyncQueued: 'Sync queued',
    kpiBroken: 'Broken',
    kpiDocsHint: 'Dokumente im Alias',
    kpiBrokenHint: 'Mapping prüfen',
    kpiBrokenOk: 'Alles in Ordnung',
    kpiSyncHint: 'Warten auf Upsync',

    mappingTitle: 'Mapping aktualisieren',
    mappingIntro:
      'Erstellt neue Indizes mit aktuellem Mapping, reindexiert asynchron und tauscht Aliase.',
    mappingKeepOpen: 'Tab offen lassen bis 100 % / Done.',
    mappingUpdate: 'Update Mapping',
    mappingStarting: 'Starting…',
    mappingReindexRunning: 'Reindex läuft… {index}',
    mappingFinalizing: 'Aliase werden finalisiert…',
    mappingDone: 'Fertig (100 %). Neue Indizes: {indices}',
    mappingFailed: 'Fehlgeschlagen: {error}',
    mappingReindexError:
      'Reindex-Fehler — Orphans in der Indizes-Tabelle prüfen und löschen.',
    mappingProgressLabel: 'Gesamtfortschritt',
    mappingWaitingEs: 'warte auf ES…',
    mappingFinished: 'fertig',
    mappingDocs: '{done} / {total} docs',

    indicesTitle: 'Indizes',
    indicesIntro:
      'Live = Alias aktiv. Orphan = kein Alias. Broken = Mapping fehlt/falsch (z. B. contact.location kein geo_point). Liste kommt vom konfigurierten ELASTICSEARCH_HOST.',
    indicesPanelTitle: 'Cluster-Indizes',
    indicesOrphanCount: '{n} Orphan',
    indicesOrphanCountPlural: '{n} Orphans',
    indicesBrokenCount: '{n} Broken',
    indicesLoading: 'Lade Indizes…',
    indicesEmptyTitle: 'Keine Indizes',
    indicesEmpty: 'Cluster leer oder nicht erreichbar.',
    colIndex: 'Index',
    colStatus: 'Status',
    colAliases: 'Aliases',
    colDocs: 'Docs',
    colSize: 'Size',
    colMapping: 'Mapping',
    colAction: 'Aktion',
    statusLive: 'Live',
    statusOrphan: 'Orphan',
    statusBroken: 'Broken',
    statusOther: 'other',
    mappingOk: 'OK',
    protected: 'geschützt',
    delete: 'Löschen',

    deleteConfirmTitle: 'Index löschen?',
    deleteConfirmLead: 'Orphan-Index ohne Live-Alias wird entfernt:',
    deleteConfirmHint:
      'Live-Indizes mit Alias award / releases / dynamic_fields sind geschützt.',
    deleteConfirm: 'Endgültig löschen',
    deleteFailed: 'Löschen fehlgeschlagen: {error}',

    syncTitle: 'Sync & Blocked',
    syncIntro:
      'Warteschlange für den nächsten ES-Upsync und blockierte Awardees ohne Awards.',
    syncQueueTitle: 'Sync-Warteschlange',
    syncQueueEmpty: 'Keine Einträge in der Warteschlange.',
    syncTotal: 'Total',
    blockedReload: 'Blocked neu laden',
    unblockAll: 'Unblock All',
    unblockAllConfirmTitle: 'Unblock all?',
    unblockAllConfirmBody:
      'Entfernt die no-awards-Blockierung für alle gelisteten Entitäten.',
    blockedTitle: 'Blocked Contacts / Accounts',
    blockedCount: '{n} Einträge',
    blockedLoading: 'Lade…',
    blockedEmptyTitle: 'Keine Blockierungen',
    blockedEmpty: 'Keine betroffenen Entitäten gefunden.',
    colType: 'Typ',
    colShortCode: 'short_code',
    colBlockedAt: 'blocked_at',
    unblock: 'Unblock',
    unblockedEntities: 'Entsperrte Entitäten: {n}'
  },
  en: {
    title: 'Elasticsearch',
    intro:
      'Status, mapping rotation, and index cleanup for the DWH search cluster.',

    statusOnline: 'Online',
    statusOffline: 'Offline / error',
    clusterLocal: 'Local',
    clusterStage: 'Stage',
    clusterProd: 'Prod',
    clusterCustom: 'Custom',
    clusterUnknown: 'Unknown',
    refresh: 'Refresh',

    warningEmptyTitle:
      'Alias/index missing (e.g. award). Cluster is empty or aliases are missing.',
    warningEmptyBody:
      'Local Docker ES is often empty. View stage/prod indices on stage.ffdwh.de / ffdwh.de (IAM there has ES access).',
    warningForbiddenTitle: 'No access to this Elasticsearch',
    warningForbiddenBody:
      'Local AWS credentials are not allowed to read this OpenSearch (es:ESHttp*). Use the admin UI on stage.ffdwh.de for stage.',

    kpiAwards: 'Awards',
    kpiReleases: 'Releases',
    kpiDynamicFields: 'Dynamic fields',
    kpiSyncQueued: 'Sync queued',
    kpiBroken: 'Broken',
    kpiDocsHint: 'Documents in alias',
    kpiBrokenHint: 'Check mapping',
    kpiBrokenOk: 'All clear',
    kpiSyncHint: 'Waiting for upsync',

    mappingTitle: 'Update mapping',
    mappingIntro:
      'Creates new indices with the current mapping, reindexes asynchronously, and swaps aliases.',
    mappingKeepOpen: 'Keep this tab open until 100% / Done.',
    mappingUpdate: 'Update Mapping',
    mappingStarting: 'Starting…',
    mappingReindexRunning: 'Reindex running… {index}',
    mappingFinalizing: 'Finalizing aliases…',
    mappingDone: 'Done (100%). New indices: {indices}',
    mappingFailed: 'Failed: {error}',
    mappingReindexError:
      'Reindex error — check Orphans in the indices table and delete them.',
    mappingProgressLabel: 'Overall progress',
    mappingWaitingEs: 'waiting for ES…',
    mappingFinished: 'done',
    mappingDocs: '{done} / {total} docs',

    indicesTitle: 'Indices',
    indicesIntro:
      'Live = alias active. Orphan = no alias. Broken = mapping missing/wrong (e.g. contact.location not geo_point). List comes from the configured ELASTICSEARCH_HOST.',
    indicesPanelTitle: 'Cluster indices',
    indicesOrphanCount: '{n} orphan',
    indicesOrphanCountPlural: '{n} orphans',
    indicesBrokenCount: '{n} broken',
    indicesLoading: 'Loading indices…',
    indicesEmptyTitle: 'No indices',
    indicesEmpty: 'Cluster is empty or unreachable.',
    colIndex: 'Index',
    colStatus: 'Status',
    colAliases: 'Aliases',
    colDocs: 'Docs',
    colSize: 'Size',
    colMapping: 'Mapping',
    colAction: 'Action',
    statusLive: 'Live',
    statusOrphan: 'Orphan',
    statusBroken: 'Broken',
    statusOther: 'other',
    mappingOk: 'OK',
    protected: 'protected',
    delete: 'Delete',

    deleteConfirmTitle: 'Delete index?',
    deleteConfirmLead: 'Orphan index without a live alias will be removed:',
    deleteConfirmHint:
      'Live indices with alias award / releases / dynamic_fields are protected.',
    deleteConfirm: 'Delete permanently',
    deleteFailed: 'Delete failed: {error}',

    syncTitle: 'Sync & blocked',
    syncIntro:
      'Queue for the next ES upsync and blocked awardees without awards.',
    syncQueueTitle: 'Sync queue',
    syncQueueEmpty: 'Nothing in the queue.',
    syncTotal: 'Total',
    blockedReload: 'Reload blocked',
    unblockAll: 'Unblock All',
    unblockAllConfirmTitle: 'Unblock all?',
    unblockAllConfirmBody:
      'Removes the no-awards block for every listed entity.',
    blockedTitle: 'Blocked contacts / accounts',
    blockedCount: '{n} entries',
    blockedLoading: 'Loading…',
    blockedEmptyTitle: 'No blocks',
    blockedEmpty: 'No affected entities found.',
    colType: 'Type',
    colShortCode: 'short_code',
    colBlockedAt: 'blocked_at',
    unblock: 'Unblock',
    unblockedEntities: 'Unblocked entities: {n}'
  }
}

export function elasticsearchT (lang, key, vars) {
  let text = adminT(ELASTICSEARCH_MESSAGES, lang, key)
  if (vars && typeof vars === 'object') {
    Object.keys(vars).forEach((name) => {
      text = String(text).split('{' + name + '}').join(String(vars[name]))
    })
  }
  return text
}
